import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ESystemAccess } from 'src/app/enum/EAccess';
import { FlujoCreditoLightService } from 'src/app/shared/services/flujo-credito-light.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-flujo-credito-light-model-selection',
  templateUrl: './flujo-credito-light-model-selection.component.html',
  styleUrls: ['./flujo-credito-light-model-selection.component.scss']
})

export class FlujoCreditoLightModelSelectionComponent {

    private canAccessFlujoCreditoLight = false;

    public modelForm = this.fb.group({
        model: [{value: '', disabled: true}],
    });

    models: string[] = [];
    isLoadingModels = true;

    constructor(
        private fb: FormBuilder,
        private flujoCreditoLightService: FlujoCreditoLightService,
        private router: Router,
        private _sessionService: SessionService
    ) { }

    ngOnInit(): void {

        this.canAccessFlujoCreditoLight = this.setCanAccessFlujoCreditoLight();

        if (!this.canAccessFlujoCreditoLight) {
            this.router.navigate(['/request-access']);
            return;
        }

        this.getModels();

        this.modelForm.get('model')?.valueChanges.subscribe(selectedModel => {
            if (!selectedModel) return;

            this.flujoCreditoLightService.setModelo(selectedModel);
            this.router.navigate(['/flujo-credito-light']);
        });

    }

    setCanAccessFlujoCreditoLight () {
        const userAccess = this._sessionService.getUserAccess();

        const flujoCreditoLightPermission = [
            ESystemAccess.FLUJO_CREDITO_LIGHT,
            ESystemAccess.FLUJO_CREDITO_LIGHT_ADMIN,
            ESystemAccess.FLUJO_CREDITO_LIGHT_BUSCAR,
        ]

        return flujoCreditoLightPermission.some(permission => userAccess.includes(permission));
    }

    getModels(): void {
        this.isLoadingModels = true;
        this.flujoCreditoLightService.getPermissions().subscribe(
            permissions => {
                const allModels = permissions.flatMap(item => item.models || []);

                this.models = Array.from(new Set(allModels)).filter(model => !!model);
                this.isLoadingModels = false;
                this.modelForm.get('model')?.enable();
            },
            error => {
                console.error('Error fetching data:', error);
            }
        );
    }
}
